
    const data = {"name":"src/core/icons/page-last","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M5.59 7.41 10.18 12l-4.59 4.59L7 18l6-6-6-6-1.41 1.41M16 6h2v12h-2V6Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            